import { Entregable as ModelClass } from "@/models/Entregable.model";
import { PaginaProvider, usePagina } from "@base/hooks/usePagina/usePagina";
import { createFileRoute } from "@tanstack/react-router";
import { DetalleLayout } from "@base/components/layout/crud/DetalleLayout";
import formulario from "./-components/formulario";

export const Route = createFileRoute("/(auth)/entregas/detalle")({
  component: () => (
    <PaginaProvider titulo={`Detalle de ${ModelClass.CLASS_NAME}`}>
      <RouteComponent />
    </PaginaProvider>
  ),
});

function RouteComponent() {
  const { handleVolver, queryParams, isEditando } = usePagina();

  return (
    <DetalleLayout
      handleVolver={handleVolver}
      queryParams={queryParams}
      isEditando={isEditando}
      nombrePlural={`${ModelClass.CLASS_NAME}s`}
      showHeader={false}
      nombreSingular={ModelClass.CLASS_NAME}
      queryProps={{
        endpoint: ModelClass.ENDPOINTS.DEFAULT,
        extraParams: {
          id: queryParams?.id,
          expand: "factura,entregas,entregas.factura.estatusCfdis,proyecto",
        },
        enabled: !!queryParams?.id,
      }}
      Formulario={formulario}
    />
  );
}
